// Multiselect field validator - must pass custom Error whenever this field is mandatory

export default ({ mandatory = false, customError = null }) => ({
  presence: mandatory && {
    allowEmpty: !mandatory,
    message: customError && `^${customError}`
  }
});
